import { render, staticRenderFns } from "./refund-goods.vue?vue&type=template&id=b324b39e&scoped=true"
import script from "./refund-goods.vue?vue&type=script&lang=js"
export * from "./refund-goods.vue?vue&type=script&lang=js"
import style0 from "./refund-goods.vue?vue&type=style&index=0&id=b324b39e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b324b39e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b324b39e')) {
      api.createRecord('b324b39e', component.options)
    } else {
      api.reload('b324b39e', component.options)
    }
    module.hot.accept("./refund-goods.vue?vue&type=template&id=b324b39e&scoped=true", function () {
      api.rerender('b324b39e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/preSale-management/preSale-delivery/refund-goods.vue"
export default component.exports